export enum MyMercatusOwner {
    Organiser = 0,
    MyMercatusUser = 1,
}
